// Dependencies
import React from 'react';
import Intercom, { hide, onHide, onShow, show, update } from '@intercom/messenger-js-sdk';

// Material UI
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'src/store/store';
import Iconify from './Iconify';

export const IntercomChat = () => {
  const [showChat, setShowChat] = React.useState(false);

  // Redux
  const user = useSelector((state) => state.auth.user);
  const language = useSelector((state) => state.auth.preferences.language);
  const theme = useTheme();

  /**
   * IMPORTANT: Replace the following variables with the actual user data
   */
  Intercom({
    app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID || '',
    ...(!!user && {
      user_id: String(user.uid),
      name: user.name,
    }),
    language: language,
    language_override: language,
    alignment: theme.direction === 'rtl' ? 'left' : 'right',
    hide_default_launcher: true,
  });

  React.useEffect(() => {
    update({
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID || '',
      ...(!!user && {
        user_id: String(user.uid),
        name: user.name,
      }),
      language: language,
      language_override: language,
      alignment: theme.direction === 'rtl' ? 'left' : 'right',
      hide_default_launcher: true,
    });
  }, [user, language, theme.direction]);

  const handleChatOpen = React.useCallback(() => {
    if (!showChat) {
      show();
    } else {
      hide();
    }
  }, [showChat]);

  //
  if (typeof window !== 'undefined') {
    onShow(() => {
      setShowChat(true);
    });

    onHide(() => {
      setShowChat(false);
    });
  }

  return (
    <Button
      id="intercom-chat-button"
      onClick={handleChatOpen}
      sx={{
        position: 'fixed',
        bottom: '20%',
        right: 0,
        padding: 0,
        minWidth: 'unset',
        height: 80,
        width: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(theme.direction === 'rtl' && {
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }),
        ...(theme.direction === 'ltr' && {
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }),
        zIndex: 2147483000,
      }}
      size="large"
      color="inherit"
      variant="contained"
    >
      <Iconify icon="solar:chat-line-bold" width={32} height={32} />
    </Button>
  );
};
